import instance from '@/utils/axios';

/**
 * 事件统计api
 * @param {*} data
 * @param {*} data.beginTime
 * @param {*} data.endTime
 * @returns
 */
export function eventStatSever(data) {
  return instance.post('airDefense/alarmEvent/eventTypeStatistic', data);
}
